export default __webpack_public_path__ + "static/apercu-bold-941d0ae40bb471d3852d0b636527dd97.ttf";